<h4 class="msg-popup" mat-dialog-title>{{data.message}}</h4>
<div mat-dialog-actions>
  <button class="btn btn-primary" mat-button mat-dialog-close>Close</button>
</div>
